import AuthenticatedController from './AuthenticatedController';
import * as APIRoutes from '@mm/api-routes';
import { CtmAdEntity } from '../model/CtmAdModel';
import AdConfigModel from '../model/AdConfigModel';
import { MessengerAdModel } from '../model/MessengerAdModel';

export class CtmAdController extends AuthenticatedController {
  static getAll(botId: number) {
    return super.get(APIRoutes.CTM_ADS(botId));
  }

  static getById(botId: number, ctmAdId: number) {
    return super.get(APIRoutes.CTM_AD(botId, ctmAdId));
  }

  static postCtmAd(botId: number, entity: CtmAdEntity) {
    return super.post(APIRoutes.CTM_ADS(botId), entity);
  }

  static putCtmAd(
    botId: number,
    entity: (Partial<AdConfigModel> | Partial<MessengerAdModel>) & {
      id: number;
    },
  ) {
    return super.put(APIRoutes.CTM_AD(botId, entity.id), entity);
  }

  static deleteCtmAd(botId: number, ctmAdId: number) {
    return super.delete(APIRoutes.CTM_AD(botId, ctmAdId));
  }
}
